export default "__VITE_ASSET__eae8e8ca__"